/* unplugin-vue-components disabled */import script from "./PublishResult.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublishResult.vue?vue&type=script&lang=ts&setup=true"

import "./PublishResult.vue?vue&type=style&index=0&id=32039d65&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32039d65"]])

export default __exports__